"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EXT_MSG = exports.SUPPRESSION_SOURCES = exports.LEAD_STATUSES = exports.AUDIT_EVENT_TYPES = exports.TONE_PRESETS = exports.MAX_CONSECUTIVE_FAILURES = exports.DEFAULT_BATCH_PACING_MS = exports.MAX_BATCH_SIZE = exports.EMAIL_CONTENT_RETENTION_DAYS = exports.UNSUBSCRIBE_TOKEN_EXPIRY_DAYS = void 0;
exports.UNSUBSCRIBE_TOKEN_EXPIRY_DAYS = 90;
exports.EMAIL_CONTENT_RETENTION_DAYS = 7;
exports.MAX_BATCH_SIZE = 100;
exports.DEFAULT_BATCH_PACING_MS = 2000;
exports.MAX_CONSECUTIVE_FAILURES = 3;
/** @deprecated Tone presets are no longer used in the email generation prompt */
exports.TONE_PRESETS = ['professional', 'friendly', 'direct', 'casual'];
exports.AUDIT_EVENT_TYPES = [
    'lead.created',
    'lead.imported',
    'email.generated',
    'draft.requested',
    'draft.created',
    'draft.failed',
    'unsubscribe.clicked',
    'suppression.created',
    'suppression.removed',
];
exports.LEAD_STATUSES = ['new', 'generated', 'drafted', 'sent', 'replied'];
exports.SUPPRESSION_SOURCES = ['unsubscribe_link', 'manual', 'import'];
/** Extension message types */
exports.EXT_MSG = {
    DRAFT_REQUEST: 'HYPEMA_DRAFT_REQUEST',
    DRAFT_RESULT: 'HYPEMA_DRAFT_RESULT',
    PING: 'HYPEMA_PING',
    PONG: 'HYPEMA_PONG',
    CREATE_DRAFT: 'EXT_CREATE_DRAFT',
    DRAFT_STATUS: 'EXT_DRAFT_RESULT',
    BATCH_START: 'HYPEMA_BATCH_START',
    BATCH_END: 'HYPEMA_BATCH_END',
    SYNC_REPLIES: 'HYPEMA_SYNC_REPLIES',
    REPLY_RESULTS: 'HYPEMA_REPLY_RESULTS',
};
//# sourceMappingURL=constants.js.map